import React from "react";
import "./LanguageBadge.scss";

//short labels of the ISO3 language codes of products and series, shown as badge on the cover
const LANGUAGE_BADGE_LABELS = {
    deu: "DE",
    eng: "EN",
    spa: "ES",
    fra: "FR",
    swe: "SV",
    gsw: "CH",
    fin: "FI",
    ita: "IT",
    nld: "NL",
    tur: "TR",
};

function getLanguageBadgeLabel(language) {
    if (!language) {
        return null;
    }
    return LANGUAGE_BADGE_LABELS[language.toLowerCase()] || language.toUpperCase();
}

//language of a product or series in the upper right corner of its cover,
//the parent element of the badge has to be positioned
export const LanguageBadge = ({language}) => {
    const label = getLanguageBadgeLabel(language);
    if (!label) {
        return null;
    }
    return <div className="cover-language-badge">{label}</div>;
};
